









import {Component, Prop, Vue} from 'vue-property-decorator';

import InputComponent from '@/components/FormElements/InputComponent.vue';
import LabelComponent from '@/components/FormElements/LabelComponent.vue';

@Component({
  components: {
    InputComponent,
    LabelComponent,
  },
})
export default class TextResponse extends Vue {
  @Prop() public readonly value!: string | null;
  @Prop(Array) public readonly choices!: string[];

  get responseValue() {
    return this.value;
  }

  set responseValue(newValue) {
    this.$emit('input', newValue);
  }
}
